export class SponsorCodeUsageModel {
	uuid: string
	merchantId:  string
	id: number
	sponsorCodeId: number
	eventUuid: string
	tktQuotaUuid: string
	catUuid: string
	plUuid: string
	nrParkings: number

	constructor() {
		this.sponsorCodeId = null;
		this.eventUuid = '';
		this.tktQuotaUuid = null;
		this.catUuid = '';
		this.plUuid = '';
		this.nrParkings = 0;
	}
}




// WEBPACK FOOTER //
// ./src/app/models/sponsor-code-usage.model.ts